import m from "../../geodata/es2015/bosniaHerzegovinaLow";
window.am4geodata_bosniaHerzegovinaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bosniaHerzegovinaLow.js
// module id = null
// module chunks = 